import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight, Search } from 'lucide-react';
import apiService from '../../../apiService';
import { fmtInt, fmtDateTime, Card, Spinner, usePeriodControls } from '../financeShared';

const ACTION_LABELS = {
  'client_balance.adjust': 'Ajustement solde client',
  'expense.create': 'Dépense créée', 'expense.update': 'Dépense modifiée', 'expense.delete': 'Dépense supprimée',
};

export default function AuditTab() {
  const { params, qs, controls } = usePeriodControls('alltime', 'month');
  const [action, setAction] = useState('');
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const p = new URLSearchParams(qs());
      p.set('page', page);
      if (action.trim()) p.set('action', action.trim());
      const res = await apiService.get(`/admin/finance/audit?${p}`, { userType: 'admin' });
      if (res?.success) setData(res);
    } catch (e) { console.error('finance audit:', e); } finally { setLoading(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, page, action]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { setPage(1); }, [params, action]);

  const logs = data?.logs || [];

  return (
    <>
      {controls({ showGroupBy: false })}
      <div style={{ position: 'relative', maxWidth: 320, marginBottom: '1.25rem' }}>
        <Search size={15} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#9AA0A8' }} />
        <input value={action} onChange={e => setAction(e.target.value)} placeholder="Filtrer par action…" style={{ width: '100%', padding: '0.45rem 0.6rem 0.45rem 2rem', borderRadius: '6px', border: '1px solid #E9EBEF', fontSize: '0.85rem' }} />
      </div>

      <Card style={{ padding: 0, overflow: 'hidden' }}>
        {loading ? <div style={{ padding: '2rem' }}><Spinner /></div> : logs.length === 0 ? <p style={{ color: '#9AA0A8', padding: '2rem' }}>Aucune action financière enregistrée.</p> : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr style={{ background: '#FFFFFF', borderBottom: '2px solid #E9EBEF' }}>
                {['Date', 'Admin', 'Action', 'Cible', 'Détails'].map(h => (
                  <th key={h} style={{ padding: '0.7rem 1rem', textAlign: 'left', fontWeight: 700, color: '#414852', fontSize: '0.75rem', textTransform: 'uppercase' }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {logs.map((l, idx) => (
                  <tr key={l.log_id} style={{ borderBottom: '1px solid #E9EBEF', background: idx % 2 === 0 ? '#fff' : '#FFFFFF' }}>
                    <td style={{ padding: '0.6rem 1rem', color: '#5C636E', fontSize: '0.8rem', whiteSpace: 'nowrap' }}>{fmtDateTime(l.created_at)}</td>
                    <td style={{ padding: '0.6rem 1rem', color: '#1E2229', fontSize: '0.82rem', fontWeight: 600 }}>{l.admin_name || l.admin_id}</td>
                    <td style={{ padding: '0.6rem 1rem' }}><span style={{ fontSize: '0.74rem', padding: '0.15rem 0.5rem', borderRadius: '10px', background: '#ECFDF5', color: '#10B981', fontWeight: 600 }}>{ACTION_LABELS[l.action] || l.action}</span></td>
                    <td style={{ padding: '0.6rem 1rem', color: '#414852', fontSize: '0.8rem', fontFamily: 'monospace' }}>{l.target_type}{l.target_id ? `:${l.target_id}` : ''}</td>
                    <td style={{ padding: '0.6rem 1rem', color: '#9AA0A8', fontSize: '0.76rem', maxWidth: 280, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.details ? JSON.stringify(l.details) : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>

      {data?.pages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', marginTop: '1.25rem' }}>
          <button className="btn-secondary" disabled={page <= 1} onClick={() => setPage(p => p - 1)} style={{ padding: '0.4rem 0.8rem', display: 'flex', alignItems: 'center', gap: 4 }}><ChevronLeft size={15} /> Préc.</button>
          <span style={{ fontSize: '0.85rem', color: '#5C636E' }}>Page {page} / {data.pages} · {fmtInt(data.total)} entrées</span>
          <button className="btn-secondary" disabled={page >= data.pages} onClick={() => setPage(p => p + 1)} style={{ padding: '0.4rem 0.8rem', display: 'flex', alignItems: 'center', gap: 4 }}>Suiv. <ChevronRight size={15} /></button>
        </div>
      )}
    </>
  );
}
